import React from "react";
import { formatWeightValue } from "../utils/packagingMaterial.utils";

interface PackagingTotalWeightBadgeProps {
  label: string;
  value: number | string;
  unit?: string;
}

/** Small "Total Weight of X: Y kg" badge shown next to a packaging level's unit row. */
const PackagingTotalWeightBadge: React.FC<PackagingTotalWeightBadgeProps> = ({ label, value, unit }) => (
  <div className="tw-shrink-0 tw-flex tw-items-center tw-gap-2 tw-bg-muted/30 tw-rounded-lg tw-px-4 tw-py-2.5 tw-border tw-border-border">
    <span className="tw-text-xs tw-font-medium tw-text-foreground tw-whitespace-nowrap">{label}</span>
    <span className="tw-text-sm tw-font-mono tw-font-semibold tw-text-primary">
      {formatWeightValue(value, unit)}
    </span>
  </div>
);

export default PackagingTotalWeightBadge;
